import { createSlice } from "@reduxjs/toolkit";
import {
  getSingleTrainingMaterial,
  GetTrainingMaterialData,
  TrainingMaterialInitialStatus,
} from "../../../types/trainingMaterial/trainingMaterial";
import {
  createTrainingMaterialAsync,
  getAllTrainingMaterialAsync,
  singTrainingMaterialAsync,
  updateTrainingMaterialAsync,
} from "./trainingMaterialApi";

const initialState: TrainingMaterialInitialStatus<
  GetTrainingMaterialData,
  getSingleTrainingMaterial
> = {
  loading: false,
  manageLoading: false,
  trainingMaterialList: [],
  singleTrainingMaterialData: null,
  countTrainingMaterial: 0,
};

const trainingMaterialSlice = createSlice({
  name: "admin-Training-Material",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createTrainingMaterialAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createTrainingMaterialAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createTrainingMaterialAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllTrainingMaterialAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllTrainingMaterialAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.trainingMaterialList = action.payload.data;
        state.countTrainingMaterial = action.payload.length;
      })
      .addCase(getAllTrainingMaterialAsync.rejected, (state) => {
        state.loading = false;
        state.trainingMaterialList = [];
        state.countTrainingMaterial = 0;
      });

    // update
    builder
      .addCase(updateTrainingMaterialAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateTrainingMaterialAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateTrainingMaterialAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singTrainingMaterialAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleTrainingMaterialData = null;
      })
      .addCase(singTrainingMaterialAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleTrainingMaterialData = action.payload;
      })
      .addCase(singTrainingMaterialAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleTrainingMaterialData = null;
      });
  },
});

export default trainingMaterialSlice;
